import type { ProductData } from "~/domains/product/types/ProductData";
import { ProductType } from "~/domains/product/types/ProductData";
import type { NetPriceData } from "~/domains/pricing/types/PriceData";
import type { AddToCartResponseItem } from "~/features/cart/cart/api/AddToCart";
import { TranslationType } from "~/common/types/TranslationModel";

export function getAddToCartResponsePrice(item: AddToCartResponseItem): NetPriceData | undefined {
  const price = item.netPrice ?? item.actualSalePrice ?? item.actualNetPrice;

  if (!price) {
    return undefined;
  }

  return {
    value: price.value,
    currencyIso: price.currencyIso,
    unit: item.priceUnit ?? 1,
    baseValue: item.actualNetPrice?.value ?? price.value,
    surcharge: 0,
    isSpecial: Boolean(item.specialPrice),
  };
}

export function mapAddToCartResponseItemsToAnalyticsProducts(items: AddToCartResponseItem[]) {
  return items.map((item) => ({
    product: getProductDataForResponseItem(item),
    price: getAddToCartResponsePrice(item),
    quantity: item.quantity,
    packaging: {
      code: item.packCode,
      size: item.packSize,
    },
  }));
}

export function getProductDataForResponseItem(item: AddToCartResponseItem): ProductData {
  return {
    code: item.productCode,
    hybrisCode: item.productCode,
    pnaCode: item.productCode,
    type: ProductType.DEFAULT,
    images: [],
    url: "",
    designation: item.designation,
    marketDesignation: item.designation,
    displayMMDAssistant: false,
    cmnSearchMatched: false,
    sapMaterialNumber: item.sapMaterialNumber,
    shortDescription: {
      type: TranslationType.RAW_TEXT,
      value: "",
    },
    description: "",
    baseType: "",
    aliases: [],
    packageAliases: {},
    productLineId: "",
    productAllCategories: [],
    isOptime: false,
    quantityVisible: true,
    isPMA: false,
    marketType: null,
    fifteenDigit: {},
    gpsdGroup: null,
    alternativeProducts: [],
    predecessorProducts: [],
    features: [],
    technicalDetails: [],
    numberOfBolts: "",
    salesCampaign: item.salesCampaignCode
      ? {
          [item.packCode]: [
            {
              code: item.salesCampaignCode,
              quantity: item.quantity,
            },
          ],
        }
      : {},
    configuratorTypes: [],
    categoryName: "",
  } as ProductData;
}
